export default __webpack_public_path__ + "guide--vector-tiles-standards-ccw-480-e587e723fa7757d761882065a883b3d4.webp";